import { render, staticRenderFns } from "./RouterOutputItem.vue?vue&type=template&id=ffd7d988&scoped=true"
import script from "./RouterOutputItem.vue?vue&type=script&lang=js"
export * from "./RouterOutputItem.vue?vue&type=script&lang=js"
import style0 from "./RouterOutputItem.vue?vue&type=style&index=0&id=ffd7d988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd7d988",
  null
  
)

export default component.exports